import { applyMachineTranslateFix } from './applyMachineTranslateFix';

/** Checks if page is already translated (Google, Edge, Safari, etc.) */
const isAlreadyTranslated = (): boolean => {
    const html = document.documentElement;
    const title = document.getElementsByTagName('title')[0];

    return (
        html.classList.contains('translated-ltr') ||
        html.classList.contains('translated-rtl') ||
        (title?.hasAttribute('_msttexthash') ?? false) ||
        html.hasAttribute('translate') ||
        document.body?.querySelector('font.notranslate, font[style]') !== null
    );
};

/**
 * Detects machine translation and applies DOM fix.
 * Called from GlobalCss as fallback; main fix is in gatsby-browser.js.
 */
export const detectMachineTranslation = (): void => {
    if (typeof window === 'undefined') {
        return;
    }

    // Check if already translated at initialization time
    if (isAlreadyTranslated()) {
        applyMachineTranslateFix();
    }

    const originalLang = document.documentElement.lang;

    // Monitor lang attribute changes (Chrome, Firefox, Safari)
    const langObserver = new MutationObserver(() => {
        if (document.documentElement.lang !== originalLang) {
            applyMachineTranslateFix();
        }
    });

    langObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });

    // Monitor Edge translator
    const title = document.getElementsByTagName('title')[0];

    if (title) {
        const edgeObserver = new MutationObserver(() => {
            if (title.hasAttribute('_msttexthash')) {
                applyMachineTranslateFix();
            }
        });

        edgeObserver.observe(title, { attributes: true, attributeFilter: ['_msttexthash'] });
    }
};
